import { Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";

import InfoItemLabel from "./InfoItemLabel";
import InfoItemValue from "./InfoItemValue";

const InfoGridItem = ({
  label,
  value,
  // labelFontSize = "0.75em",
  labelFontSize = "12px",
  valueFontSize = "0.95em",
  fullWidth = false,
  suppressAutoMobile = false,
}) => {
  return (
    <FlxGrid
      suppressAutoMobile={suppressAutoMobile}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.1,
        gridColumn: fullWidth ? "1 / -1" : "auto",
      }}
    >
      <InfoItemLabel fontSize={labelFontSize}>{label}</InfoItemLabel>
      <InfoItemValue fontSize={valueFontSize}>{value || "N/A"}</InfoItemValue>
    </FlxGrid>
  );
};
export default InfoGridItem;
